import React from "react";
import {
  freeDelivery,
  protectedPackaging,
  securisedPayment,
} from "src/assets/images/reassurance";
import { translate } from "src/services/translation.service";
import theme, { media } from "src/theme";
import { IProduct } from "src/types/product";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  margin: ${theme.margins.marginBig} auto 0 auto;
  max-width: 420px;

  ${media.tablet} {
    margin: ${theme.margins.marginBig} 0 0 0;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Image = styled.img`
  width: 40%;
`;

const Text = styled.div`
  margin-top: ${theme.margins.marginMedium};
  padding: 0 5px;
  font-size: 11px;

  p {
    margin: 0;
  }
`;

const Uppercase = styled.p`
  text-transform: uppercase;
`;

interface IProps {
  product: IProduct;
}

const ProductReassuranceBar = ({ product }: IProps): JSX.Element => {
  const deliveryType = (): number => {
    const freeDeliveryStandard = product.actualPrice >= 130;

    if (freeDeliveryStandard) {
      return 2;
    }

    return 1;
  };

  return (
    <Wrapper>
      <Item>
        <Image
          src={freeDelivery}
          alt={translate("product.reassurance.delivery")}
        />
        <Text>
          <Uppercase>
            {translate("product.reassurance.freeDeliveryOffer")}
          </Uppercase>
          <p>
            {translate(`product.reassurance.freeDelivery${deliveryType()}`)}
          </p>
        </Text>
      </Item>
      {deliveryType() === 3 ? (
        <Item>
          <Image
            src={protectedPackaging}
            alt={translate("product.reassurance.protectedPackaging1")}
          />
          <Text>
            <Uppercase>
              {translate("product.reassurance.collectorDelivery1")}
            </Uppercase>
            <p>{translate("product.reassurance.collectorDelivery2")}</p>
          </Text>
        </Item>
      ) : (
        <Item>
          <Image
            src={protectedPackaging}
            alt={translate("product.reassurance.protectedPackaging1")}
          />
          <Text>
            <Uppercase>
              {translate("product.reassurance.protectedPackaging1")}
            </Uppercase>
            <p>{translate("product.reassurance.protectedPackaging2")}</p>
          </Text>
        </Item>
      )}
      <Item>
        <Image
          src={securisedPayment}
          alt={translate("product.reassurance.securisedPayment1")}
        />
        <Text>
          <Uppercase>
            {translate("product.reassurance.securisedPayment1")}
          </Uppercase>
          <p>{translate("product.reassurance.securisedPayment2")}</p>
        </Text>
      </Item>
    </Wrapper>
  );
};

export default ProductReassuranceBar;
